<umkt-auth-layout scrollable>
  <div class="auth-back">
    <a (click)="openLogoutConfirm()" style="cursor: pointer;">
      Sair
      <mat-icon class="logout-icon" style="margin-left: 8px;">logout</mat-icon>
    </a>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 class="title-text font-highlight">
            Escolha um contrato para continuar
          </h1>
          <p class="subtitle-text">
            Os produtos contratados serão vinculados ao contrato escolhido.
            <span *ngIf="companyName" style="display: block; margin-top: 4px;">
              <strong>Empresa:</strong> {{ companyName }}
            </span>
          </p>
        </div>

        <!-- Search Bar -->
        <div class="search-container">
          <div class="search-input-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input 
              type="text" 
              placeholder="Buscar contrato"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              class="search-input"
              #searchInput
            >
            <mat-icon 
              *ngIf="searchTerm" 
              class="clear-icon" 
              (click)="clearSearch()"
              style="cursor: pointer;"
            >close</mat-icon>
          </div>
        </div>

        <!-- Loading State -->
        <umkt-loading
          *ngIf="loading"
          [isLoading]="true"
          [size]="'md'"
          [mode]="'contained'"
          [showText]="true"
          [text]="'shared.messages.loading' | i18n"
        ></umkt-loading>

        <!-- Contract List -->
        <div *ngIf="!loading" class="contract-list" [class.scrollable]="hasMoreThanFourItems">
          <div 
            *ngFor="let contract of filteredContracts; trackBy: trackByContract"
            class="contract-option"
            [class.selected]="selectedContract?.customerAccountId === contract.customerAccountId"
            (click)="selectContract(contract)"
          >
            <div class="contract-icon">
              <mat-icon class="business-icon">receipt_long</mat-icon>
            </div>
            <div class="contract-info">
              <div class="contract-number">
                {{ fixaContractDisplayLabel(contract) }}
              </div>
              <div class="contract-details">
                <span class="contract-status" [class]="getStatusClass(contract.status)">
                  {{ getStatusLabel(contract.status) }}
                </span>
                <span class="contract-separator">•</span>
                <span class="contract-source">{{ contract.sourceSystemDescription }}</span>
              </div>
            </div>
            <div class="contract-arrow">
              <mat-icon class="arrow-icon">chevron_right</mat-icon>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && filteredContracts.length === 0" class="empty-state">
          <mat-icon class="empty-icon">receipt_long</mat-icon>
          <p class="empty-text">Nenhum contrato encontrado</p>
          <p class="empty-subtext">Tente ajustar os termos da busca</p>
        </div>

        <!-- Help Section -->
        <div class="help-section">
          <p class="help-text">
            <strong>Não encontrou o contrato? </strong>
          </p>
          <p>
            Fale com a gente pelo chat na tela inicial ou entre em contato com o nosso time de atendimento.
          </p>
        </div>
      </div>
    </div>
  </div>

  <umkt-confirm-modal
    [open]="showLogoutConfirm"
    variant="danger"
    icon="bi bi-exclamation-triangle"
    title="Deseja sair?"
    message="Ao sair, será necessário fazer login novamente para aproveitar todas as soluções do Hub."
    (confirm)="handleLogoutConfirm()"
    (canceled)="handleLogoutCancel()"
    (closed)="handleLogoutCancel()"
    confirmText="Sair"
    cancelText="Cancelar"
  ></umkt-confirm-modal>
</umkt-auth-layout>

